import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-digclose",
  "use": "icon-digclose-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" fill=\"none\" id=\"icon-digclose\">\r\n          <rect x=\"0.34375\" y=\"10.2422\" width=\"14\" height=\"2\" rx=\"1\" transform=\"rotate(-45 0.34375 10.2422)\" fill=\"#FFE8D0\" />\r\n          <rect x=\"1.75781\" y=\"0.342773\" width=\"14\" height=\"2\" rx=\"1\" transform=\"rotate(45 1.75781 0.342773)\" fill=\"#FFE8D0\" />\r\n        </symbol>"
});
var result = sprite.add(symbol);
export default symbol